import {fromJS} from 'immutable';
import * as types from 'constants/action-types';
import {
  setRecordsReducer,
  setCurrentRecordPageReducer,
  setCurrentRecordReducer,
  clearRecordsAfterPageReducer,
} from './base';

const initialState = fromJS({
  messagePages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentMessage: {},
});

const setMessagesReducer = (state, action) => setRecordsReducer('message', state, action);

const setCurrentMessagePageReducer = (state, action) => setCurrentRecordPageReducer('message', state, action);

const setCurrentMessageReducer = (state, action) => setCurrentRecordReducer('message', state, action);

const clearMessagesAfterPageReducer = (state, action) => clearRecordsAfterPageReducer('message', state, action);

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    case types.SET_MESSAGES:
      return setMessagesReducer(state, action);
    case types.SET_CURRENT_MESSAGE_PAGE:
      return setCurrentMessagePageReducer(state, action);
    case types.SET_CURRENT_MESSAGE:
      return setCurrentMessageReducer(state, action);
    case types.CLEAR_MESSAGES_AFTER_PAGE:
      return clearMessagesAfterPageReducer(state, action);
    default:
      return state;
  }
};
